module.exports = __webpack_public_path__ + "media/images/photography/grown_up_cms/audrey-317a210c7685c25824e659b6c73370a2.jpg";